import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../components/Accountant/ui/Sidebar';
import Header from '../components/Accountant/ui/Header';

const AccountantLayout: React.FC = () => {
  const location = useLocation();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    if (mobileNavOpen) {
      document.body.style.overflow = 'hidden';
    }
  }, [mobileNavOpen]);

  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, []);

  const getPageTitle = (pathname: string) => {
    if (pathname.startsWith('/accountant/settlements/')) {
      return 'Vendor Ledger Details';
    }
    if (pathname.startsWith('/accountant/ledger/order/')) {
      return 'Order Ledger Details';
    }
    switch (pathname) {
      case '/accountant/dashboard':
        return 'Finance Dashboard';
      case '/accountant/settlements':
        return 'Vendor Settlements';
      case '/accountant/manual-refund-cases':
        return 'Manual refund cases';
      case '/accountant/ledger':
        return 'Ledger';
      case '/accountant/ledger/customer':
        return 'Customer Ledger';
      case '/accountant/ledger/vendor':
        return 'Vendor Ledger';
      case '/accountant/ledger/vendor/medicine':
        return 'Medicine Service Ledger';
      case '/accountant/ledger/vendor/ambulance':
        return 'Ambulance Service Ledger';
      case '/accountant/ledger/vendor/doctor':
        return 'Doctor Consultation Service Ledger';
      case '/accountant/ledger/delivery-partner':
        return 'Delivery Partner Ledger';
      case '/accountant/ledger/razorpay':
        return 'Razorpay Ledger';
      case '/accountant/ledger/bank':
        return 'Bank Account Ledger';
      case '/accountant/ledger/commission':
        return 'Commission Ledger';
      case '/accountant/ledger/profit-loss':
        return 'Profit and Loss Ledger';
      case '/accountant/ledger/gst':
        return 'GST Ledger';
      case '/accountant/reports':
        return 'Financial Reports';
      case '/accountant/audit':
        return 'Audit & Compliance';
      case '/accountant/settings':
        return 'Settings';
      case '/accountant/help':
        return 'Help & Support';
      default:
        return 'Accountant Dashboard';
    }
  };

  return (
    <div className="flex h-dvh max-h-dvh overflow-hidden bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <div
        className={`fixed inset-0 z-40 bg-black/50 transition-opacity duration-200 lg:hidden ${
          mobileNavOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
        aria-hidden
        onClick={() => setMobileNavOpen(false)}
      />
      <Sidebar mobileOpen={mobileNavOpen} onCloseMobile={() => setMobileNavOpen(false)} />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col bg-gray-50 dark:bg-gray-900">
        <Header
          title={getPageTitle(location.pathname)}
          onOpenMobileNav={() => setMobileNavOpen(true)}
        />
        <main className="min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden bg-gray-50 px-3 py-3 text-gray-900 dark:bg-gray-900 dark:text-gray-100 sm:px-4 sm:py-4 md:px-6 md:py-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AccountantLayout;
